import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useAuth } from "../../context/AuthContext"

const Login = () => {
  const { t } = useTranslation()
  const { tcsSignIn } = useAuth()

  const tcsLogin = async (_e: React.MouseEvent<HTMLElement>) => {
    _e.preventDefault();
    try {
      await tcsSignIn();
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      <h1>{t('login')}</h1>
      <Button
        variant="contained"
        color="secondary"
        type="button"
        onClick={tcsLogin}
      >
        {t('TCS Online Account')}
      </Button>
    </div>
  )
}

export default Login
